import { StoreModel } from '../../store/models/StoreModel';

export class ChannelStoreModel {
    id?: number = undefined;
    store: StoreModel = new StoreModel();

    constructor(c?: Partial<ChannelStoreModel>) {
        Object.assign(this, c)
        this._parseStoreModel()
    }

    private _parseStoreModel():void {
        this.store = new StoreModel(this.store);
    }
}
